/**
 * Export utilities
 *
 * Client-side CSV and JSON export — triggers a browser file download.
 */

function triggerDownload(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

function escapeCSVField(value: unknown): string {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * UTF-8 BOM. Excel has no way to detect a CSV's encoding on open and
 * defaults to the system codepage (Windows-1252), so any non-ASCII byte
 * (em-dash, accented name, curly quote, ...) renders as mojibake (e.g.
 * `â€"`) unless the file leads with this marker (issue #713).
 */
const UTF8_BOM = '﻿';

export function exportToCSV(rows: Record<string, unknown>[], filename: string): void {
  if (rows.length === 0) return;

  const headers = Object.keys(rows[0]);
  const headerRow = headers.map(escapeCSVField).join(',');
  const dataRows = rows.map((row) =>
    // h is from Object.keys of DB rows (internal field names filtered from DB schema) — not user input
    // eslint-disable-next-line security/detect-object-injection
    headers.map((h) => escapeCSVField(row[h])).join(',')
  );
  const csv = UTF8_BOM + [headerRow, ...dataRows].join('\n');

  triggerDownload(csv, filename.endsWith('.csv') ? filename : `${filename}.csv`, 'text/csv');
}

export function exportToJSON(rows: unknown[], filename: string): void {
  const json = JSON.stringify(rows, null, 2);
  triggerDownload(
    json,
    filename.endsWith('.json') ? filename : `${filename}.json`,
    'application/json'
  );
}
